import { render, staticRenderFns } from "./tab_part_replace_record.vue?vue&type=template&id=4c32fc0c&scoped=true"
import script from "./tab_part_replace_record.vue?vue&type=script&lang=js"
export * from "./tab_part_replace_record.vue?vue&type=script&lang=js"
import style0 from "./tab_part_replace_record.vue?vue&type=style&index=0&id=4c32fc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32fc0c",
  null
  
)

export default component.exports